import { useState, useEffect } from 'react'
import './team-rank.css'
import './copy-button.css'
import './composition-card.css'
import CompositionHeader from './CompositionHeader'
import { useClipboard } from '../../hooks/useClipboard'
import PairCard from './PairCard'
import ChampionList from '../champion-list/ChampionList'

function CompositionCard({
  composition,
  pairs,
  imageMap,
  itemComponents,
  itemImageMap,
  highlight,
}) {
  const [showPairs, setShowPairs] = useState(false)
  const [wasClicked, setWasClicked] = useState(false)
  const [highlightActive, setHighlightActive] = useState(highlight)
  const { copied: copiedCode, copy } = useClipboard()

  useEffect(() => {
    const seenHighlight = localStorage.getItem('seenHighlight')
    if (seenHighlight) {
      setHighlightActive(false)
    } else {
      setHighlightActive(highlight)
    }
  }, [highlight])

  const handleClick = () => {
    setShowPairs((prev) => !prev)
    setWasClicked(true)
    setHighlightActive(false)
    localStorage.setItem('seenHighlight', 'true')
  }

  return (
    <div
      onClick={handleClick}
      className={`composition-card ${highlightActive && !wasClicked ? 'highlight' : ''}`}
    >
      <CompositionHeader
        tier={composition.tier}
        name={composition.name}
        playStyle={composition.play_style}
        code={composition.planner_code}
        copiedCode={copiedCode}
        handleCopy={copy}
      />

      <ChampionList
        champions={composition.champions}
        imageMap={imageMap}
        itemComponents={itemComponents}
        itemImageMap={itemImageMap}
      />

      <div className={`pairs-wrapper ${showPairs ? 'visible' : 'hidden'}`}>
        {pairs.map((pair, i) => (
          <PairCard
            key={i}
            pair={pair}
            imageMap={imageMap}
            itemComponents={itemComponents}
            itemImageMap={itemImageMap}
            copiedCode={copiedCode}
            handleCopy={copy}
          />
        ))}
      </div>
    </div>
  )
}

export default CompositionCard
